/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Author info in a comment.created notification.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface CommentCreatedUser { 
    id: number;
    name: string;
}
export const CommentCreatedUser_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommentCreatedUser_name_Validators: ValidatorFn[] =
    [  Validators.required, ];


